


















































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate, maskHour } from '@/utils/common'

@Component

export default class ComponenteBackofficePaciente extends Vue {
  headers: any[] = [
    { text: '', align: 'center', value: '', sortable: false },
    { text: '1° Fornecedor', class: 'table-headers-email', align: 'left', value: 'fornecedor1', sortable: false },
    { text: '2° Fornecedor', class: 'table-headers-email', align: 'left', value: 'fornecedor2', sortable: false },
    { text: '3° Fornecedor', class: 'table-headers-email', align: 'left', value: 'fornecedor3', sortable: false },
    { text: 'Justificativa', class: 'table-headers-email', align: 'left', value: 'justificativa', sortable: false },
  ]

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getOpmesFornecedor() {
    return this.getBackofficeGlobalStore.solicitacao.opmeFornecedores
  }

  get getOpmes() {
    const fornecedor1: string = ''
    const fornecedor2: string = ''
    const fornecedor3: string = ''
    const opmes: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.opmes) {
      this.getBackofficeGlobalStore.solicitacao.opmes.map((c) => {
        opmes.push({
          id: c.id,
          termo: c.termo,
          quantidade: c.quantidade,
          justificativa: c.justificativa,
          fornecedor1: c.fornecedores && c.fornecedores[0] ? `${c.fornecedores[0].nome}/ ${c.fornecedores[0].fabricante || ''}` : '',
          fornecedor2: c.fornecedores && c.fornecedores[1] ? `${c.fornecedores[1].nome}/ ${c.fornecedores[1].fabricante || ''}` : '',
          fornecedor3: c.fornecedores && c.fornecedores[2] ? `${c.fornecedores[2].nome}/ ${c.fornecedores[2].fabricante || ''}` : '',
        })
        return c
      })
    }
    return opmes
  }
}
